import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomergroupService } from 'src/app/services/customergroup.service';
import { Customerservice } from 'src/app/model/customerservice.model';

@Component({
  standalone: false,
  selector: 'app-change-user-group-single',
  templateUrl: './change-user-group-single.component.html',
  styleUrls: ['./change-user-group-single.component.scss'],
})
export class ChangeUserGroupSingleComponent implements OnInit {
  @Input() listofusers: any;
  @Input() singleUserId: any;

  public customerservice = new Customerservice();

  prakList: any = [];
  public formData: any;
  finalSubmissionArray = [];
  newlyAddedGroupIds = [];
  mainGroups = [];
  mainUserList = [];
  selectedGroupIds = [];
  selectedParkIds = [];
  onlyGroupIdsArray = [];
  CSGSelectFocused: boolean = true;
  memberDetails: any;
  userSelectedGroupIds = [];

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private customergroupService: CustomergroupService
  ) {
    this.myForm = this.formBuilder.group({
      newUsersGroups: this.formBuilder.array([this.newNotes()]),
      createdBy: '',
      isActive: true,
    });
  }

  ngOnInit(): void {
    this.getTheMainServiceGroupList();
    this.getMemberDetails();
  }

  newUsersGroups(): FormArray {
    return this.myForm.get('newUsersGroups') as FormArray;
  }

  newNotes(): FormGroup {
    return this.formBuilder.group({
      groupid: ['', Validators.required],
    });
  }

  onSubmit() {

    console.log(this.listofusers);

    if (this.myForm.valid) {

      this.newlyAddedGroupIds = [];
      for (let i = 0; i <= this.myForm.value.newUsersGroups.length - 1; i++) {
        this.newlyAddedGroupIds.push(
          this.myForm.value.newUsersGroups[i].groupid,
        );
      }

      console.log(this.newlyAddedGroupIds[0]);

      this.finalSubmissionArray = [];
      for (let i = 0; i <= this.listofusers.length - 1; i++) {
        this.finalSubmissionArray.push({
          'userId': this.listofusers[i].userId ? this.listofusers[i].userId : this.listofusers[i].memberId,
          'groupIds': this.newlyAddedGroupIds[0],
          'createdBy': localStorage.getItem('claAdminId')
        });
      }

      console.log(this.finalSubmissionArray);

      this.customergroupService
        .changeServiceUserGroup(this.finalSubmissionArray)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            location.reload();
          }
        });
      this.modal.dismiss();
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  getTheMainServiceGroupList() {
    this.customergroupService.getMainGroupList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainGroups = res?.list;
      }
    });
  }

  selectGroupData(e) {
    for (let i = 0; i <= e.length - 1; i++) {
      this.selectedGroupIds.push(e[i].groupId);
    }
    this.selectedGroupIds = this.selectedGroupIds.filter((value, index, array) => array.indexOf(value) === index);
  }

  clearSelectedData() {
    this.selectedGroupIds.length = 0;
  }

  onCSGSelectOpen(index) {
    console.log(index);
    this.CSGSelectFocused = true;
  }

  getMemberDetails() {
    this.customergroupService.getMemberDetailsSingle(this.singleUserId).subscribe((res) => {
      if (res?.isValid === true) {
        this.memberDetails = res;
        this.customerservice.userid = this.memberDetails.data?.memberId;
        for (let i = 0; i <= this.memberDetails.data?.serviceGroups.length - 1; i++) {
          this.userSelectedGroupIds.push(this.memberDetails.data?.serviceGroups[i].groupId);
        }
        this.customerservice.userSelectedGroupIds = this.userSelectedGroupIds;      }
    });
  }
}
